<script lang="ts" setup>
import BaseLabel, { BaseLabelColor } from '@/atoms/BaseLabel.vue';
import BottomButtons from '@/molecules/BottomButtons.vue';
import { cva } from 'class-variance-authority';
import { computed, defineAsyncComponent } from 'vue';
import { cn } from '@/helpers/tailwind-helpers';
import BaseButton, { BaseButtonProps } from '@/atoms/BaseButton.vue';

export type BottomSheetProps = {
  class?: string;
  illustrationName?: string;
  title: string;
  description?: string;
  descriptionColor?: BaseLabelColor;
  center?: boolean;
  headerButtonProps?: BaseButtonProps | false;
};

const props = defineProps<BottomSheetProps>();

const bottomSheet = cva('flex flex-col pt-6 px-4 rounded-xl bg-bg-primary', {
  variants: {
    center: {
      true: 'items-center text-center',
      false: '',
    },
  },
  defaultVariants: {},
});

const classes = computed(() => cn(bottomSheet(props), props.class));

const IllustrationComponent = computed(() =>
  defineAsyncComponent(() => import(`../assets/illustrations/${props.illustrationName}.svg`)),
);
</script>

<template>
  <div :class="classes">
    <component :is="IllustrationComponent" v-if="illustrationName" class="w-20 h-20" />
    <slot v-else name="header" />

    <div class="flex justify-between">
      <div class="flex flex-col space-y-1">
        <BaseLabel :text="title" preset="h3" weight="medium" />
        <BaseLabel :color="descriptionColor" :text="description" preset="medium" weight="regular" />
      </div>
      <BaseButton v-if="headerButtonProps" v-bind="headerButtonProps" />
    </div>

    <slot />

    <BottomButtons :fixed="false" class="w-full">
      <slot name="bottom-buttons" />
    </BottomButtons>
  </div>
</template>
